<script>
  import Edit from "carbon-icons-svelte/lib/Edit.svelte";
  import YardDeatils from "../../../forms/Yard/YardDeatils.svelte";
  import CompanyForm from "../../../forms/Company/CompanyForm.svelte";
  import { yards, quoteSelectedMaterial } from "../../../stores";
  import { reportYardImageError, getYardName } from "../../../helpers";

  let selectedYard = null;
  let showYardDetails = false;
  let showYardCompany = false;
  let yardCompany = {};

  function mouseEnter(yardId) {
    const marker = document.getElementById("yard-marker-" + yardId);
    if (marker) {
      marker.classList.add("marker-hovered");
    }
  }

  function mouseLeave(yardId) {
    const marker = document.getElementById("yard-marker-" + yardId);
    if (marker) {
      marker.classList.remove("marker-hovered");
    }
  }

  function clickShowYardDetails(yard) {
    selectedYard = yard;
    showYardDetails = true;
  }

  function setShowYardCompany(e) {
    yardCompany = e.detail;
    showYardCompany = true;
  }

  function saveCompanyDetails() {
    if (selectedYard) {
      selectedYard.company = yardCompany;
    }
    showYardCompany = false;
  }

  /**
   * Retrieves the lowest material price for the currently selected material.
   */
  function getMaterialPrice(yard, selectedMaterial) {
    if (!yard || !yard.accepts) return null;
    let mat = null;
    if (selectedMaterial && selectedMaterial !== "All") {
      mat = yard.accepts.find((m) => m.name === selectedMaterial);
    } else if (yard.accepts.length > 0) {
      mat = yard.accepts.find((m) => m.prices && m.prices.length > 0) || yard.accepts[0];
    }
    if (!mat || !mat.prices || mat.prices.length === 0) return null;

    let lowest = null;
    for (const p of mat.prices) {
      const val = parseFloat(p.price);
      if (!isNaN(val) && (lowest === null || val < lowest.val)) {
        lowest = { val, item: p };
      }
    }
    return lowest ? lowest.item : null;
  }
</script>

<div class="compact-yards-section">
  <div class="compact-yards-header">
    <span class="header-label">Available Disposal Yards</span>
    <span class="count-pill">{$yards ? $yards.length : 0} Yards</span>
  </div>

  <div class="compact-yards-scroll">
    {#if $yards && $yards.length > 0}
      {#each $yards as yard (yard.id)}
        {@const priceItem = getMaterialPrice(yard, $quoteSelectedMaterial)}
        <div
          id={"yard-price-" + yard.id}
          class="compact-yard-row"
          title="Double-click to view and edit yard details"
          on:mouseenter={() => mouseEnter(yard.id)}
          on:mouseleave={() => mouseLeave(yard.id)}
          on:dblclick={() => clickShowYardDetails(yard)}
        >
          <div class="yard-meta-left">
            {#if yard.image}
              <img
                class="yard-avatar"
                src={"./assests/yards/" + yard.image}
                alt=""
                on:error={(e) => {
                  reportYardImageError(yard, "not_found", "./assests/yards/" + yard.image);
                  e.currentTarget.style.display = "none";
                  const fallback = e.currentTarget.parentElement.querySelector(".placeholder-avatar");
                  if (fallback) fallback.style.display = "flex";
                }}
              />
              <div class="yard-avatar placeholder-avatar" style="display: none;">🏭</div>
            {:else}
              <div class="yard-avatar placeholder-avatar">🏭</div>
            {/if}
            <span
              class="yard-title"
              title={getYardName(yard)}
            >
              {getYardName(yard)}
            </span>
            <span class="yard-locality">
              {yard.address && yard.address.suburb
                ? yard.address.suburb
                : yard.address
                  ? yard.address.street
                  : ""}
            </span>
          </div>

          <div class="yard-meta-right">
            {#if priceItem}
              <span class="price-chip">
                ${parseFloat(priceItem.price)}/{priceItem.unit ? priceItem.unit.charAt(0).toLowerCase() : 't'}
              </span>
            {/if}

            {#if yard.load && yard.load.costs && yard.load.costs.total_tonne_price}
              <span class="haul-chip {yard.load.cheapest ? 'best-deal' : ''}">
                ${yard.load.costs.total_tonne_price}/t total
              </span>
            {/if}

            <button
              class="yard-quick-edit"
              on:click|stopPropagation={() => clickShowYardDetails(yard)}
              title="View & Edit Yard Details"
              type="button"
            >
              <Edit size={13} />
            </button>
          </div>
        </div>
      {/each}
    {:else}
      <div class="empty-yards-box">
        <span>No matching disposal yards for selected material</span>
      </div>
    {/if}
  </div>
</div>

{#if showYardDetails && selectedYard}
  <YardDeatils
    yardId={selectedYard.id}
    bind:yard={selectedYard}
    on:close={() => (showYardDetails = false)}
    on:yard-saved={(e) => {
      if (e.detail) {
        $yards = ($yards || []).map((y) => (y.id === e.detail.id ? { ...y, ...e.detail } : y));
      }
    }}
    on:saved={(e) => {
      if (e.detail) {
        $yards = ($yards || []).map((y) => (y.id === e.detail.id ? { ...y, ...e.detail } : y));
      }
    }}
    on:edit-company={setShowYardCompany}
  />
{/if}

{#if showYardCompany}
  <CompanyForm
    bind:company={yardCompany}
    on:close={() => (showYardCompany = false)}
    on:company-saved={saveCompanyDetails}
  />
{/if}

<style>
  .compact-yards-section {
    display: flex;
    flex-direction: column;
    gap: 6px;
    background-color: var(--tt-slate-50);
    border: 1px solid var(--tt-slate-200);
    border-radius: var(--tt-radius-md);
    padding: 8px 10px;
  }

  .compact-yards-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 2px;
  }

  .header-label {
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: var(--tt-slate-600);
  }

  .count-pill {
    font-size: 11px;
    font-weight: 700;
    color: var(--tt-primary);
    background-color: rgba(66, 133, 244, 0.08);
    padding: 1px 7px;
    border-radius: 9999px;
  }

  .compact-yards-scroll {
    display: flex;
    flex-direction: column;
    gap: 4px;
    max-height: 135px;
    overflow-y: auto;
    overscroll-behavior: contain;
    padding-right: 3px;
    scrollbar-width: thin;
    scrollbar-color: var(--tt-slate-300) transparent;
  }

  .compact-yards-scroll::-webkit-scrollbar {
    width: 4px;
  }

  .compact-yards-scroll::-webkit-scrollbar-thumb {
    background: var(--tt-slate-300);
    border-radius: 4px;
  }

  .compact-yard-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    background-color: #ffffff;
    border: 1px solid var(--tt-slate-200);
    border-radius: var(--tt-radius-sm);
    padding: 5px 8px;
    min-height: 32px;
    cursor: pointer;
    user-select: none;
    transition: all 0.12s ease;
  }

  .compact-yard-row:hover {
    border-color: var(--tt-primary);
    background-color: #f8fbff;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
  }

  .yard-meta-left {
    display: flex;
    align-items: center;
    gap: 6px;
    min-width: 0;
    flex: 1;
  }

  .yard-avatar {
    width: 20px;
    height: 20px;
    border-radius: 4px;
    object-fit: cover;
    border: 1px solid var(--tt-slate-200);
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    background-color: var(--tt-slate-100);
  }

  .placeholder-avatar {
    line-height: 20px;
    text-align: center;
  }

  .yard-title {
    font-size: 11.5px;
    font-weight: 700;
    color: var(--tt-slate-900);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 175px;
  }

  .yard-locality {
    font-size: 10.5px;
    font-weight: 500;
    color: var(--tt-slate-500);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100px;
  }

  .yard-meta-right {
    display: flex;
    align-items: center;
    gap: 6px;
    flex-shrink: 0;
  }

  .price-chip {
    font-size: 11.5px;
    font-weight: 700;
    color: var(--tt-slate-900);
    background-color: var(--tt-slate-100);
    padding: 2px 6px;
    border-radius: 4px;
    white-space: nowrap;
    border: 1px solid var(--tt-slate-200);
  }

  .haul-chip {
    font-size: 11px;
    font-weight: 700;
    color: var(--tt-slate-700);
    background-color: #f1f5f9;
    padding: 2px 6px;
    border-radius: 4px;
    white-space: nowrap;
  }

  .haul-chip.best-deal {
    color: #15803d;
    background-color: #ecfdf5;
    border: 1px solid #bbf7d0;
  }

  .yard-quick-edit {
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    border: none;
    color: var(--tt-slate-400);
    cursor: pointer;
    border-radius: 3px;
    padding: 0;
    transition: all 0.12s ease;
  }

  .yard-quick-edit:hover {
    color: var(--tt-slate-800);
    background-color: var(--tt-slate-200);
  }

  .empty-yards-box {
    padding: 12px;
    text-align: center;
    font-size: 11px;
    color: var(--tt-slate-400);
    font-style: italic;
  }
</style>
